import { Component, HostBinding } from '@angular/core';
import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import {
  ActivePageService,
  IsAdminService,
  LastChildRouteService,
  ThemeService,
  TokenRefreshService,
} from '@aptitude/shared';
import { Sizes } from '@aptitude/shared';
import { EnvironmentService } from '@aptitude/environment';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  @HostBinding('class') classes = 'flex-column';
  loading = false;
  themeLoading = false;
  firstLoad = false;
  Sizes = Sizes;

  constructor(
    router: Router,
    isAdminService: IsAdminService,
    lastChildRouteService: LastChildRouteService,
    titleService: Title,
    activePageService: ActivePageService,
    themeService: ThemeService,
    environmentService: EnvironmentService,
    tokenRefreshService: TokenRefreshService,
  ) {
    environmentService.setEnvironmentData(environment);
    router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          if (!this.firstLoad) {
            this.loading = true;
          }
          this.firstLoad = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
      }
    });

    lastChildRouteService.routeData$.subscribe((routeData) => {
      activePageService.setActivePage(routeData.activePage);

      if (isAdminService.isAdmin) {
        titleService.setTitle(`${routeData.title} | aptitude Admin`);
      } else {
        titleService.setTitle(routeData.title);
      }
    });

    themeService.themeLoading$.subscribe(
      (themeLoading) => (this.themeLoading = themeLoading),
    );
  }
}
